import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";
import { CondominioContextoDTO } from "types/dto/CondominioContextoDTO";

export const useGetCondominioContexto = (condominioContexto: string | null, setCondominiContexto: Function) => {
  const onSuccess = (response: CondominioContextoDTO) => {
    setCondominiContexto(response);
  };

  const onError = () => {
    toast.error("Erro ao buscar condominio contexto");
  };
  return useFetch<CondominioContextoDTO>({
    key: ["user-context", condominioContexto],
    url: `${api.condominio.getCondominioContexto}/${condominioContexto}`,
    enabled: !!condominioContexto,
    onSuccess,
    onError,
    config: {
      staleTime: Infinity,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: false,
    },
  });
};
